import { device } from 'components/styles/MediaQuery';
import styled from 'styled-components';

export const ScReferralProgram = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 32px;
  overflow: hidden;
  color: ${({ theme }) => theme.whiteColor};

  .title {
    font-size: 22px;
    line-height: 28px;
    letter-spacing: 0.22px;
    font-weight: 700;
  }

  .wrapper-description {
    display: flex;
    flex-direction: column;
    text-align: center;
    height: 76px;
    justify-content: space-between;
  }

  .desctiption {
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0px;
  }

  .character {
    height: 72px;
    border-radius: 12px;
  }

  .button-wrapper {
    width: 232px;
    height: 48px;
  }

  @media (${device.mobileS}) {
    .button-wrapper {
      width: 100%;
    }

    .title {
      font-size: 18px;
      line-height: 24px;
      letter-spacing: 0.18px;
    }
  }
`;
